(() => {
  const desktop = window.matchMedia('(min-width: 901px)');

  const buildGuide = root => {
    if (root.dataset.bnGuideReady) return;
    const content = root.querySelector('[data-bn-article-content]');
    const contents = root.querySelector('[data-bn-article-contents]');
    const list = root.querySelector('[data-bn-article-contents-list]');
    const details = contents && contents.querySelector('details');
    if (!content || !contents || !list || !details) return;

    const headings = [...content.querySelectorAll('h2, h3')].filter(heading =>
      heading.textContent.trim() && !heading.closest('[hidden], [aria-hidden="true"]')
    );
    const prefix = `bn-article-${root.dataset.bnArticleId || 'guide'}`;
    let itemCount = 0;

    headings.forEach((heading, index) => {
      const label = heading.textContent.trim().replace(/\s+/g, ' ');
      if (!heading.id) {
        const slug = label.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || `heading-${index + 1}`;
        const base = `${prefix}-${slug}`;
        let id = base;
        let suffix = 2;
        while (document.getElementById(id)) id = `${base}-${suffix++}`;
        heading.id = id;
      }
      if (document.getElementById(heading.id) !== heading) return;

      const item = document.createElement('li');
      if (heading.tagName === 'H3') item.className = 'bn-coastal-article__contents-subheading';
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = label;
      link.addEventListener('click', () => {
        if (!desktop.matches) details.open = false;
        for (let parent = heading.parentElement; parent && parent !== content; parent = parent.parentElement) {
          if (parent.tagName === 'DETAILS') parent.open = true;
        }
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      });
      item.append(link);
      list.append(item);
      itemCount += 1;
    });

    root.dataset.bnGuideReady = 'true';
    if (!itemCount) {
      root.classList.add('bn-coastal-article--without-contents');
      return;
    }
    details.open = desktop.matches;
    contents.hidden = false;
  };

  const init = context => {
    if (context.matches && context.matches('[data-bn-article-guide]')) buildGuide(context);
    context.querySelectorAll('[data-bn-article-guide]').forEach(buildGuide);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', event => init(event.target));
  desktop.addEventListener('change', event => {
    document.querySelectorAll('[data-bn-article-contents]:not([hidden]) details').forEach(details => {
      details.open = event.matches;
    });
  });
})();
